import Cookies from "js-cookie"
import { html } from "lit-html"

const ButtonForm = ({ url, label, formClass, buttonClass }) => html`
  <form method="POST" action=${url} class="button-form ${formClass || ""}">
    <input
      type="hidden"
      name="csrfmiddlewaretoken"
      value=${Cookies.get("csrftoken")}
    />
    <button class="${buttonClass}" type="submit">${label}</button>
  </form>
`

export default ButtonForm
